import { api } from './api';

export type EventInfoPayload = {
  eventName: string;
  payload: Record<string, any>;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class EventInfo {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location?.origin || '', 'api/'].join('/');
    }

    return '';
  }

  static async send(payload: EventInfoPayload, headers?: Record<string, any>) {
    const response = await api.post(`${EventInfo.BASE_PATH}eventInfo`, payload, headers);
    return response;
  }
}
